<template>
  <div class="details-wrap">
    <div class="title-wrap">
      <div class="right-wrap">
        <BaseButton class="vote-btn" @click="voteEvent">投票</BaseButton>
        <el-checkbox
          class="vote-check"
          v-model="baseData.isChecked"
          @change="voteChangeEvent($event, baseData)"
          >选择当前作品</el-checkbox
        >
      </div>
      <div class="selected">
        <el-badge :value="selectedArr.length" class="item">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-selected"></use>
          </svg>
        </el-badge>
        <span>已选</span>
      </div>
    </div>

    <div class="works-info-wrap">
      <div class="works">
        <h2>{{ baseData.worksname }} {{ baseData.author }}</h2>
      </div>
      <div class="works-info">
        <span>作品分类：{{ baseData.workstype }}</span
        ><span>
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-views"></use></svg
          >{{ baseData.pageViewNumber || 0 }}</span
        >
      </div>
    </div>
    <p class="worksIntroduce">{{ baseData.worksIntroduce }}</p>

    <div class="workslist-wrap">
      <img
        :src="baseData.recommend === '500px' ? `https://images.weserv.nl/?url=${item}&w=600&fit=outside` : `${item}?x-oss-process=image/resize,p_25`"
        alt=""
        v-for="(item, index) in baseData.workslist"
        :key="index"
      />
    </div>
    <p class="show-more-wrap">
      <span @touchend="showMoreEvent">查看更多 ></span>
    </p>
    <div class="share-wrap">
      <div class="share-text">分享:</div>
      <div
        v-for="(item, index) in shareIcon"
        :key="index"
        class="share-icon"
        :class="{ 'copy-url': item === 'url' }"
        @touchend="shareEvent(item)"
        :style="{
          backgroundImage: `url(${require(`@/assets/img/share/${item}.png`)})`
        }"
      ></div>
    </div>
  </div>
</template>
<script>
import { microBlog } from "@/utils/share";
import { mapState, mapMutations } from "vuex";

import worksApi from "@/api/works";
import wxApi from "@/api/wx";
import ClipboardJS from "clipboard";

let clip;

export default {
  name: "PicCateMainMobile",
  data() {
    return {
      id: null,
      baseData: {
        workslist: [],
        isChecked: false
      },
      shareIcon: ["wechat", "weibo", "url"],
      wx: {}
    };
  },
  computed: {
    ...mapState(["env", "sortActive", "selectedArr"])
  },
  methods: {
    ...mapMutations(["setSortActive", "setSelectedArr"]),
    /**
     * 获取微信签名
     * @returns {Promise<void>}
     */
    async fetchSignatureFn() {
      let { data } = await wxApi.signature();
      this.wx = data;
      this.registerWechatFn();
    },
    /**
     * 配置微信
     */
    registerWechatFn() {
      let wechat = this.wx;
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: wechat.appID, // 必填，公众号的唯一标识
        timestamp: wechat.timestamp, // 必填，生成签名的时间戳
        nonceStr: wechat.nonceStr, // 必填，生成签名的随机串
        signature: wechat.signature, // 必填，签名，见附录1
        jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"] // 必填，需要使用的JS接口列表
      });
    },
    /**
     * 查看更多
     */
    showMoreEvent() {
      this.$router.push("/works");
    },
    /**
     * 分享
     */
    shareEvent(type) {
      if (type === "wechat" || type === "friends") {
        this.$toast("点击右上角分享到微信好友/朋友圈为作品助力");
      } else if (type === "weibo") {
        let url = microBlog({
          author: this.baseData.author,
          worksname: this.baseData.worksname,
          url: location.href,
          pic: this.baseData.workslist[0]
        });
        window.location.href = encodeURI(url);
      }
    },
    /**
     * 初始化数据
     */ async fetchData(id) {
      let data = await worksApi.fetchWorksDetails(id);
      if (data.code === 200) {
        let flag = this.selectedArr.indexOf(this.id);
        this.baseData = {
          isChecked: flag > -1 ? true : false,
          ...data.data,
          id: this.id
        };
        let _this = this;
        wx.ready(() => {
          /**
           * 分享到朋友圈
           */
          wx.onMenuShareTimeline({
            title: `#精彩的在后面#我在#明基摄影后期大赛#中看到${_this.baseData.author}的作品《${_this.baseData.worksname}》不错哦，快来为作品助力，选择你的精彩！`, // 分享标题
            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: `${_this.baseData.workslist[0]}?x-oss-process=image/resize,p_20`, // 分享图标
            success: function() {
              _this.$toast("成功分享到朋友圈");
            }
          });
          /**
           * 分享好友
           */
          wx.onMenuShareAppMessage({
            title: `#精彩的在后面#我在#明基摄影后期大赛#中看到${_this.baseData.author}的作品《${_this.baseData.worksname}》不错哦，快来为作品助力，选择你的精彩！`, // 分享标题
            desc: `${_this.baseData.worksIntroduce}`, // 分享描述
            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: `${_this.baseData.workslist[0]}?x-oss-process=image/resize,p_20`, // 分享图标
            type: "", // 分享类型,music、video或link，不填默认为link
            success: function() {
              _this.$toast("成功分享给好友");
            }
          });
        });
      }
    },
    /**
     * 初始化复制链接
     */ initCopyUrlFn() {
      let _this = this;
      this.$nextTick(() => {
        if (clip) {
          return;
        }
        clip = new ClipboardJS(".copy-url", {
          text: function(trigger) {
            _this.$toast("链接复制成功");
            return location.href;
          }
        });
      });
    },
    /**
     * 投票
     */
    async voteEvent() {
      if (this.selectedArr.length === 0) {
        this.$toast("您还没有选择作品");
        return;
      }
      let token = localStorage.getItem("token");
      if (token) {
        let { code, msg } = await worksApi.voteWorks(this.selectedArr, token);
        if (code === 200) {
          this.$toast("投票成功");
          this.clearSelectedFn();
          if (this.baseData.isChecked) {
            this.baseData.isChecked = false;
          }
        } else if (code === 201) {
          this.$toast(msg);
          this.clearSelectedFn();
          if (this.baseData.isChecked) {
            this.baseData.isChecked = false;
          }
        } else if (code === 4018) {
          localStorage.removeItem("token");
        }
      } else {
        location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx324c85c2649253d5&redirect_uri=https%3A%2F%2Fauth.benq.com.cn%2FweChat%2FgetCode&response_type=code&scope=snsapi_userinfo&state=${encodeURIComponent(
          location.origin + "/syhqds2022/wxAuth?redirect=" + location.pathname + "&"
        )}#wechat_redirect`;
      }
    },
    /**
     * 投票成功清空选择
     */
    clearSelectedFn() {
      this.setSelectedArr([]);
    },
    /**
     * 选择作品
     */
    voteChangeEvent(status, obj) {
      if (this.selectedArr.length >= 5 && status) {
        setTimeout(() => {
          obj.isChecked = false;
        }, 100);
        this.$toast("您已经选择5副作品啦！");
      } else {
        this.setSelectedArr({ status, value: obj.id });
      }
    }
  },
  created() {
    let id = this.$route.params.id;
    if (id) {
      this.id = Number(id);
      this.fetchData(id);
      if (this.env.isWx) {
        this.fetchSignatureFn();
      }
      this.initCopyUrlFn();
    } else {
      this.$router.push("/works");
    }
  }
};
</script>
<style lang="scss" scoped>
.title-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .right-wrap {
    display: flex;
    align-items: center;
    ::v-deep .el-checkbox__label {
      vertical-align: middle;
      color: $color-text-regular;
      font-size: 12px;
    }
    ::v-deep .el-checkbox__inner {
      width: 0.4rem;
      height: 0.4rem;
      border-color: $color-text-regular;
      &::after {
        left: 0.14rem;
        top: 0.05rem;
      }
      &:hover {
        border-color: #FFC15E;
      }
    }
    ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
      background: #FFC15E;
      border-color: #FFC15E;
    }
    ::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
      border-color: #FFC15E;
    }
  }
  .vote-check {
    margin-left: 0.4rem;
  }

  .selected {
    font-size: 14px;
    display: flex;
    align-items: center;
    color: $color-primary;
    margin-right: 0.333rem;
    .icon {
      width: 18px;
      height: 24px;
      // width: 0.4rem;
      // height: 0.6rem;
      vertical-align: -0.9em;
    }
    span {
      margin-left: 8px;
    }
    ::v-deep .el-badge__content.is-fixed {
      top: 2px;
      right: 12px;
    }
    ::v-deep .el-badge__content {
      background-color: #d4003b;
    }
  }
  .vote-btn {
    width: 3.067rem;
    height: 1.067rem;
    padding: 0;
  }
}
.works-info-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 0.68rem;
  .works {
    align-self: flex-start;

    h2 {
      font-size: 15px;
      color: $color-text-primary;
      font-weight: bold;
      line-height: 1;
    }
  }
  .works-info {
    color: $color-text-regular;
    span {
      &:nth-of-type(2) {
        margin-left: 0.24rem;
        svg {
          width: 1.3em;
          height: 1.3em;
          vertical-align: -0.3em;
          margin-right: 3px;
        }
      }
    }
  }
  ::v-deep .el-checkbox__label {
    vertical-align: middle;
    color: $color-text-regular;
    font-size: 12px;
  }
  ::v-deep .el-checkbox__inner {
    width: 0.4rem;
    height: 0.4rem;
    border-color: $color-text-regular;
    &::after {
      left: 4.5px;
      top: 2px;
    }
    &:hover {
      border-color: #FFC15E;
    }
  }
  ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
    background: #FFC15E;
    border-color: #FFC15E;
  }
  ::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #FFC15E;
  }
}
.details-wrap {
  padding: 0 15px;
}

.worksIntroduce {
  margin-top: 0.32rem;
  font-size: 12px;
  line-height: 20px;
  color: $color-text-primary;
}

.workslist-wrap {
  margin: 17.5px auto 35px;
  img {
    width: 100%;
    display: block;
    & + img {
      margin-top: 10px;
    }
  }
}
.show-more-wrap {
  text-align: center;
  font-size: 16px;
  color: $color-text-regular;
}
.share-wrap {
  display: flex;
  width: 187.5px;
  margin: 35px auto 200px;
  justify-content: space-between;
  .share-text {
    font-size: 14px;
    color: $color-text-regular;
  }
  .share-icon {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    width: 22.5px;
    height: 18px;
  }
}
</style>